export class LoadListFileIN {
    idFolderTree: number
    idPogetto: number
}
